/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodDonorFitness from './blood-donor-fitness';
import BloodDonorFitnessDetail from './blood-donor-fitness-detail';
import BloodDonorFitnessUpdate from './blood-donor-fitness-update';
import BloodDonorFitnessDeleteDialog from './blood-donor-fitness-delete-dialog';

const BloodDonorFitnessRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodDonorFitness />} />
    <Route path="new" element={<BloodDonorFitnessUpdate />} />
    <Route path=":id">
      <Route index element={<BloodDonorFitnessDetail />} />
      <Route path="edit" element={<BloodDonorFitnessUpdate />} />
      <Route path="delete" element={<BloodDonorFitnessDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodDonorFitnessRoutes;
